<template>
  <div>
    <NetworkCard v-if="network" :network="network" :showJoin="false" />
    <CardSmall v-if="media" :columns="3" :media="media" :index="0" :network="network" />
  </div>
</template>
<script>
import CardSmall from '../../../views/networks/media/feed/views/card/CardSmall.vue';
import NetworkCard from '@/components/commons/Networks/NetworkCard.vue';
import queryString from 'query-string';

export default {
  name: 'NextUrl',
  components: {
    CardSmall,
    NetworkCard,
  },
  props: {
    media: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      busy: false,
      network: null,
      pathsToManage: ['join-network', 'invitation', '/networks/media'],
    };
  },
  mounted() {
    this.getNetworkInfo();
  },
  methods: {
    getNetworkInfo() {
      let nextURL = this.$store.state.auth.nextURL;
      const parsedURL = new URL(nextURL, 'http://somebase.com'); // we use somebase as it does not matte

      let urlString = '';
      let token = '';
      let mediaSlug = '';
      let networkSlug = '';
      let modalTitle = this.$t('JoinNetworkMixin.to-access-this-network-login-or-start-your-journey-with-us-today');
      //Get Path String to match with allowed routes
      if (parsedURL.pathname.startsWith('/invitation')) {
        urlString = nextURL.split('/')[1].replace('/', '');
        token = nextURL.split('/')[2].replace('/', '');
        modalTitle = this.$t('NextUrl.you-ve-been-invited-to-join-the-network-to-continue-choose-from-below');
      } else if (parsedURL.pathname.startsWith('/join-network')) {
        urlString = nextURL.split('?')[0].replace('/', '');
        modalTitle = this.$t('NextUrl.you-ve-been-invited-to-join-the-network-to-continue-choose-from-below');
      } else if (parsedURL.pathname.startsWith('/networks/media/')) {
        // global media link: /networks/media/{mediaSlug}
        urlString = '/networks/media';
        mediaSlug = parsedURL.pathname.split('/')[3];
        modalTitle = this.$t('NextUrl.this-is-private-media-to-view-choose-from-below');
      } else {
        // network-scoped media link: /networks/{networkSlug}/media/{mediaSlug}
        const networkMediaMatch = parsedURL.pathname.match(/^\/networks\/([^/]+)\/media\/([^/]+)/);
        if (networkMediaMatch) {
          urlString = '/networks/media';
          networkSlug = networkMediaMatch[1];
          mediaSlug = networkMediaMatch[2];
          modalTitle = this.$t('NextUrl.this-is-private-media-to-view-choose-from-below');
        }
      }
      //Check if Path exist in Allowed Routes
      if (this.pathsToManage.includes(urlString)) {
        this.$emit('modalTitle', modalTitle);
        if (token !== '') {
          this.busy = true;
          this.$http.get('networks/members/get-invitation/' + token).then(resp => {
            this.network = resp.data.network;
            this.busy = false;
          });
        } else if (networkSlug !== '') {
          this.busy = true;
          this.$http.get('networks/' + networkSlug).then(resp => {
            this.network = resp.data;
            this.busy = false;
          }).catch(() => {
            this.busy = false;
          });
        } else if (mediaSlug !== '') {
          this.busy = true;
          this.$http.get('networks/media/' + mediaSlug).then(resp => {
            if (resp.data.networks && resp.data.networks.length === 1) {
              this.network = resp.data.networks[0];
            }
            this.busy = false;
          }).catch(() => {
            this.busy = false;
          });
        } else {
          //Get Parsed Query String
          const parsedQueryString = queryString.parse(nextURL.split('?')[1]);
          if (parsedQueryString.email) {
            this.$emit('emailFound', parsedQueryString.email);
          }
          if (parsedQueryString.network) {
            this.busy = true;
            this.$http.get('networks/' + parsedQueryString.network).then(resp => {
              this.network = resp.data;
              this.busy = false;
            });
          }
        }
      }
    },
  },
};
</script>
